import { FileText } from "lucide-react";
import type { INavItem } from "@/models/INavItem";
import { LandingPageRoutes, SharedComponentRoutes } from "./routes";
import { LandingPagePermissions } from "./permissions";

export const landingPageNav: INavItem = {
  labelKey: "nav.landing_pages",
  icon: FileText,
  path: LandingPageRoutes.DASHBOARD,
  permissions: [LandingPagePermissions.READ],
  permissionPrefix: "Travel:LandingPages:",
  children: [
    {
      labelKey: "nav.landing_pages_dashboard",
      path: LandingPageRoutes.DASHBOARD,
      permissions: [LandingPagePermissions.READ],
    },
    {
      labelKey: "nav.landing_pages_manage",
      path: LandingPageRoutes.LIST,
      permissions: [LandingPagePermissions.READ],
    },
    {
      labelKey: "nav.landing_pages_shared_components",
      path: SharedComponentRoutes.LIST,
      permissions: [LandingPagePermissions.READ],
    },
  ],
};
